export const WINDOW_STATE = {
	Open: "open",
	Minimized: "minimize",
	Overflow: "overflow",
};

export const PERSIST_DRAFT_THROTTLE = 2000;
export const PERSIST_MESSENGER_STATE_THROTTLE = 100;

export const ERROR_MESSAGE_DURATION = 3000;
export const ERROR_MESSAGE_DEFAULT = "No error response";

export const ENTER_KEY_CODE = 13;

export const SYSTEM_USERID = "0";
export const ALICE_USERID = "4170169657126759250";

export const MESSAGES_LIMIT = 20;

export const STANDALONE_PAGE_URL = "/standalone_conversation";

export const SEND_TRIGGER_TYPE = {
	ClickToSend: 0,
	EnterToSend: 1,
};



// WEBPACK FOOTER //
// ./src/apps/messenger/util/consts.js